/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Explorer_Breadcrumbs_No_Permission_ToastInputs */

const en_explorer_breadcrumbs_no_permission_toast = /** @type {(inputs: Explorer_Breadcrumbs_No_Permission_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You don't have permission to access this folder`)
};

const fr_explorer_breadcrumbs_no_permission_toast = /** @type {(inputs: Explorer_Breadcrumbs_No_Permission_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vous n'avez pas la permission d'acceder a ce dossier`)
};

const de_explorer_breadcrumbs_no_permission_toast = /** @type {(inputs: Explorer_Breadcrumbs_No_Permission_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sie haben keine Berechtigung, auf diesen Ordner zuzugreifen.`)
};

const it_explorer_breadcrumbs_no_permission_toast = /** @type {(inputs: Explorer_Breadcrumbs_No_Permission_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Non hai l'autorizzazione per accedere a questa cartella`)
};

const ru_explorer_breadcrumbs_no_permission_toast = /** @type {(inputs: Explorer_Breadcrumbs_No_Permission_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`У вас нет разрешения на доступ к этой папке.`)
};

const es_explorer_breadcrumbs_no_permission_toast = /** @type {(inputs: Explorer_Breadcrumbs_No_Permission_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No tienes permiso para acceder a esta carpeta`)
};

const zh_cn2_explorer_breadcrumbs_no_permission_toast = /** @type {(inputs: Explorer_Breadcrumbs_No_Permission_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`您没有权限访问此文件夹`)
};

const ja_explorer_breadcrumbs_no_permission_toast = /** @type {(inputs: Explorer_Breadcrumbs_No_Permission_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`このフォルダにアクセスする権限がありません`)
};

const hi_explorer_breadcrumbs_no_permission_toast = /** @type {(inputs: Explorer_Breadcrumbs_No_Permission_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`आपको इस फ़ोल्डर तक पहुँचने की अनुमति नहीं है`)
};

const pt_pt2_explorer_breadcrumbs_no_permission_toast = /** @type {(inputs: Explorer_Breadcrumbs_No_Permission_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Você não tem permissão para acessar esta pasta.`)
};

/**
* | output |
* | --- |
* | "You don't have permission to access this folder" |
*
* @param {Explorer_Breadcrumbs_No_Permission_ToastInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const explorer_breadcrumbs_no_permission_toast = /** @type {((inputs?: Explorer_Breadcrumbs_No_Permission_ToastInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Explorer_Breadcrumbs_No_Permission_ToastInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_explorer_breadcrumbs_no_permission_toast(inputs)
	if (locale === "de") return de_explorer_breadcrumbs_no_permission_toast(inputs)
	if (locale === "it") return it_explorer_breadcrumbs_no_permission_toast(inputs)
	if (locale === "ru") return ru_explorer_breadcrumbs_no_permission_toast(inputs)
	if (locale === "es") return es_explorer_breadcrumbs_no_permission_toast(inputs)
	if (locale === "zh-CN") return zh_cn2_explorer_breadcrumbs_no_permission_toast(inputs)
	if (locale === "ja") return ja_explorer_breadcrumbs_no_permission_toast(inputs)
	if (locale === "hi") return hi_explorer_breadcrumbs_no_permission_toast(inputs)
	if (locale === "pt-PT") return pt_pt2_explorer_breadcrumbs_no_permission_toast(inputs)
	return en_explorer_breadcrumbs_no_permission_toast(inputs)
});